import React from 'react';
import styled from 'styled-components';

import { COPYRIGHT, BREAK_POINTS } from '../constants';

const FooterWrapper = styled.footer`
  width: 100%;
  height: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    height: 140px;
    padding: 0 32px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    height: 120px;
    padding: 0 20px;
  }
`;

const FooterContent = styled.div`
  width: 100%;
  max-width: 1180px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    justify-content: center;
  }
`;

const Copyright = styled.p`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.04px;
  text-align: center;
  color: #969696;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    font-size: 11px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    font-size: 10px;
  }
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterContent>
        <Copyright>{COPYRIGHT}</Copyright>
      </FooterContent>
    </FooterWrapper>
  );
};

export default Footer;
